import { z } from 'zod'

import { Dispute } from './dispute'

import { Pagination } from '@/types/app/request'
import { Product, ProductBinding } from '@/types/catalogue/product'
import { Machine } from '@/types/machines/machine'

/** Payment methods availables. */
export const PaymentMethod = z.enum([
    'CASH',
    'CREDIT_CARD',
    'KONVIVES',
    'MEAL_VOUCHER',
    'PRIVATE_CARD',
])
export type PaymentMethod = z.infer<typeof PaymentMethod>

export const ProductSale = Product.pick({
    id: true,
    name: true,
    price: true,
    tva: true,
    client_serial: true,
    supplier: true,
    purchase_price: true,
}).extend({
    dlc: z.string().date(),
    price_paid: z.number(),
    product: ProductBinding,
})

export type ProductSale = z.infer<typeof ProductSale>

/** Menu object returned by the API */
export const MenuSale = z.object({
    name: z.string(),
    price: z.number(),
    products: ProductSale.array(),
})

export type MenuSale = z.infer<typeof MenuSale>

/** Discount object returned by the API */
export const DiscountSale = z.object({
    id: z.number(),
    name: z.string(),
    price: z.number(),
    unit: z.string(),
    tva: z.number(),
    products: ProductSale.array(),
})

export type DiscountSale = z.infer<typeof DiscountSale>

/** Cart discount object returned by the API */
export const CartDiscountSale = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    price: z.number().nonnegative(),
    discount_amount: z.number().positive(),
    is_participation: z.boolean(),
    menus: MenuSale.array(),
    discounts: DiscountSale.array(),
    products: ProductSale.array(),
})

export type CartDiscountSale = z.infer<typeof CartDiscountSale>

/** Sale information. */
export const Sale = z.object({
    id: z.number().positive(),
    date_time: z.string().datetime({ offset: true }),
    machine: Machine,
    payment_method: PaymentMethod,
    card_type: z.string(),
    contact_less_card: z.boolean(),
    total: z.number(),
    participation: z.number(),
    cart_discount: CartDiscountSale.optional(),
    menus: MenuSale.array(),
    discounts: DiscountSale.array(),
    products: ProductSale.array(),
    orders: z.number().array(),
    dispute_sale: Dispute.array(),
})

export type Sale = z.infer<typeof Sale>

export const SalesRequest = Pagination.extend({
    results: Sale.array(),
})

export type SalesRequest = z.infer<typeof SalesRequest>
